import { getBaseUrl } from '../utils/getBaseUrl'; 

const baseURL = getBaseUrl() + 'category/';

export const DeleteCategory = async (catId) => {
    try {
        await fetch(baseURL + 'delete', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: catId
        });
        return "Deleted category";
    } catch (error) {
        console.error('Error deleting the category:', error);
    }
};

export const GetAllCategory = async () => {
    try {
        const response = await fetch(baseURL + 'getall', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching all categories:', error);
    }
};

export const GetCategoryById = async (catId) => {
    try {
        const response = await fetch(baseURL + `getbyid?pk=${catId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error(`Error fetching category by ID (${catId}):`, error);
    }
};

export const AddCategory = async (categoryBody) => {
    try {
        await fetch(baseURL + 'add', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: categoryBody
        });
        return "Category added";
    } catch (error) {
        console.error('Error adding category:', error);
    }
};
